export const getStreamingNetworks = (notes) => {
  try {
    const notesData = JSON.parse(notes);
    return notesData?.streamingNetworks;
  } catch (error) {
    return null;
  }
};
